import React, { useEffect, useState } from "react";
import { Pagination } from "antd";

const CoustomPagination = ({ allData, setPagninatedData, pageSize}) => {
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setCurrentPage(1);
  }, [allData]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    setPagninatedData(allData.slice(startIndex, endIndex));
  }, [allData, currentPage]);

  return (
    <div style={{ marginTop: 24, display: 'flex', justifyContent: 'center' }}>
      <Pagination
        current={currentPage}
        pageSize={pageSize}
        total={allData.length}
        onChange={(page) => setCurrentPage(page)}
      />
    </div>
  );
};

export default CoustomPagination;